import firstCocktail from '../ProImg/firstCocktail.png';
import bootstrap from '../ProImg/bootstrap.png';
import keeperTodo from '../ProImg/keeperTodo.png';
import scroll from '../ProImg/scroll.png';
import stripe from '../ProImg/stripe.png';
import reduxCart from '../ProImg/reduxCart.png';


export const ProjectData = [
    {
        id: 1,
        img: firstCocktail,
        height: 300,
        dataAos: "zoom-out-down",
        anchorLink: "https://my-cocktail-shop.netlify.app/",
        siteName: "This is a Cocktail Shop Website",
        technology: "React, React router, Context Api, Cocktail DB Rest Api, CSS, HTML, React Icons.",
        category: "React Js"
    },
    {
        id: 2,
        img: reduxCart,
        height: 300,
        dataAos: "zoom-in-up",
        anchorLink: "https://redux-simple-cart.netlify.app/",
        siteName: "This is a Redux cart",
        technology: "React Js, Redux, React Icons, CSS4, HTML5",
        category: "React Js"
    }, 
    {
        id: 3,
        img: stripe,
        height: 400,
        dataAos: "zoom-in-down",
        anchorLink: "https://shawn-stripe-menu-final.netlify.app/",
        siteName: "This is stripe menu design",
        technology: "React Js, React router, CSS4, HTML5,",
        category: "React Js"
    },
    {
        id: 4,
        img: keeperTodo,
        height: 300,
        dataAos: "zoom-in-left",
        anchorLink: "https://shawn-keeper-todo.netlify.app/",
        siteName: "This a clone of Google keeper app",
        technology: "React Js, CSS4, HTML5, React Icons",
        category: "React Js"
    },
    {
        id: 5,
        img: scroll,
        height: 300,
        dataAos: "zoom-in-right",
        anchorLink: "https://shawn-vanilla-scroll-project.netlify.app/",
        siteName: "This is JavaScript scroll Effect site",
        technology: "JavaScript, CSS3, HTML5, Font Awesome Icons",
        category: "JavaScript"
    },
    {
        id: 6,
        img: bootstrap,
        height: 300,
        dataAos: "zoom-out-down",
        anchorLink: "https://shawn-bootstrap-project.netlify.app/",
        siteName: "This is a blog web design",
        technology: "HTML5, CSS4, Bootstrap v5, JavaScript",
        category: "Bootstrap"
    },
];